import { breeds, petTypes, type Breed, type PetType } from './pets-data';
import { getBreedImageUrl } from './breed-images';

export type FindYourPetBreed = Breed;
export type FindYourPetPetType = PetType;

/**
 * Find Your Pet dataset (shared with `website/src/app/data/pets-data.ts`).
 *
 * This powers the in-app "Know Your Pet" feature.
 */
export const findYourPetBreeds: FindYourPetBreed[] = breeds;
export const findYourPetPetTypes: FindYourPetPetType[] = petTypes;

export function getFindYourPetImageUrl(
  breedId: string,
  breedImage: string,
  petType: string,
  width: number = 900,
  height: number = 506
): string {
  return getBreedImageUrl(breedId, breedImage, petType, width, height);
}
